




import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class BaseNoDataDefault extends Vue {
  @Prop({ required: false, default: "No data to display" })
  message!: string;

  @Prop({ required: false, default: "" })
  spacing!: "top" | "bottom";
}
